import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import { GEGENSTAND_DER_FOERDERUNG, KOSTEN_ARTEN, KOSTEN_POSITION, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { TreeNodeType } from 'src/lib/types/types';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import {
	checkIfAllPositionIsEditable,
	checkIfAnyPositionNachKostenArtHasComment,
	checkIfHasComment,
	checkIfProjektDatenHasComment,
} from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import { TreeStructureAntragAbschlussSeiteGlobal } from '../../global-structure/abschluss-seite/TreeStructureAbschlussSeiteGlobal';
import { TreeStructureAllgemeinHinweisGlobal } from '../../global-structure/allgemeinen-hinweis/TreeStructureAllgemeinHinweisGlobal';
import { TreeStructureAnlagenGlobal } from '../../global-structure/anlagen/TreeStructureAnlagenGlobal';
import { TreeStructureAntragBescheidGlobal } from '../../global-structure/antrag-bescheid/TreestructureAntragBescheidGlobal';
import { TreeStructureAntragstellerGlobal } from '../../global-structure/antragstellerin/TreeStructureAntragstellerGlobal';
import { TreeStructureDeMinimisGlobal } from '../../global-structure/de-minimis/TreeStructureDeMinimisGlobal';
import { TreeStructureErklaerungGlobal } from '../../global-structure/erklaerung/TreeStructureErklaerungGlobal';
import { TreeStructureAntragFinanzierungsPlanGlobal } from '../../global-structure/finanzierung-plan-antrag/TreeStructureAntragFinanzierungsPlanGlobal';
import { TreeStructureSelbstErklaerungRUSGlobal } from '../../global-structure/rus-erklaerung/TreeStructureSelbstErklaerungRUSGlobal';
import { TreeStructureSelbstErklaerungKMUGlobal } from '../../global-structure/selbst-erklaerung-kmu/TreeStructureSelbstErklaerungKMUGlobal';
import { TreeStructureSelbstErklaerungBeihilferelevanzGlobal } from '../../global-structure/beihilferelevanz-erklaerung/TreeStructureSelbstErklaerungBeihilferelevanzGlobal';
import { TreeStructureAntragVorzeitigerMassnahme } from '../../global-structure/vorzeitige-massnahme/TreeStructureVorzeitigeMassnahmeGlobal';
import { TreeStructureZeitplanungGlobal } from '../../global-structure/zeitplanung/TreeStructureZeitplanungGlobal';
import EinnahmeAntragEbusse, { getFormStrucEinnahmeAntragEbusse } from './content/EinnahmeAntragEbusse';
import EinnahmeUebersichtAntragEbusse from './content/EinnahmeUebersichtAntragEbusse';
import FoerdervoraussetzungAntragEbusse, { getFormStrucFoerdervoraussetzungAntragEbusse } from './content/FoerdervoraussetzungAntragEbusse';
import InvestitionskostenAntragEbusse, { getFormStrucInvestitionskostenAntragEbusse } from './content/InvestitionskostenAntragEbusse';
import InvestitionsUebersichtAntragEbusse from './content/InvestitionsUebersichtAntragEbusse';
import AusgangssituationAntragEbusseBeschaffung, {
	getFormStrucAusgangssituationAntragEbusseBeschaffung,
} from './content/projektbeschreibung-beschaffung/AusgangssituationAntragEbusseBeschaffung';
import AusschreibungVergabeAntragEbusseBeschaffung, {
	getFormStrucAusschreibungVergabeAntragEbusseBeschaffung,
} from './content/projektbeschreibung-beschaffung/AusschreibungVergabeAntragEbusseBeschaffung';
import BeschreibungDesVorhabensAntragEbusseBeschaffung, {
	getFormStrucBeschreibungDesVorhabensAntragEbusseBeschaffung,
} from './content/projektbeschreibung-beschaffung/BeschreibungDesVorhabenAntragEbusseBeschaffung';
import AusgangssituationAntragEbusseNachruestung from './content/projektbeschreibung-nachruestung/AusgangssituationAntragEbusseNachruestung';
import AusschreibungVergabeAntragEbusseNachruestung, {
	getFormStrucAusschreibungVergabeAntragEbusseNachruestung,
} from './content/projektbeschreibung-nachruestung/AusschreibungVergabeAntragEbusseNachruestung';
import BeschaffungEinerWasserstoffAntragEbusseNachruestung, {
	getFormStrucBeschaffungEinerWasserstoffAntragEbusseNachruestung,
} from './content/projektbeschreibung-nachruestung/BeschaffungEinerWasserstoffAntragEbusseNachruestung';
import BeschaffungVonLadeinfrastrukturAntragEbusseNachruestung, {
	getFormStrucBeschaffungVonLadeinfrastrukturAntragEbusseNachruestung,
} from './content/projektbeschreibung-nachruestung/BeschaffungVonLadeinfrastrukturAntragEbusseNachruestung';
import BeschreibungDesVorhabensAntragEbusseNachruestung, {
	getFormStrucBeschreibungDesVorhabensAntragEbusseNachruestung,
} from './content/projektbeschreibung-nachruestung/BeschreibungDesVorhabensAntragEbusseNachruestung';
import ProjektDatenAntragEbusse, { getFormStrucProjektDatenAntragEbusse } from './content/ProjektDatenAntragEbusse';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

export const TreeStructureAntragEbusse = (
	application: any,
	readOnly: boolean,
	kostenKategories: any[],
	kostenKategoriesGroup: any,
	allgemeineHinweiseKMU: any,
	allgemeineHinweiseDeminimis: any,
	allgemeineHinweiseRUS: any,
	allgemeineHinweiseBeihilferelevanz: any,
): TreeNodeType[] => {
	const hasCommentProjektdaten = checkIfProjektDatenHasComment(readOnly, application);
	const isKostenEditable = checkIfAllPositionIsEditable(readOnly, application);

	let treeNodes: TreeNodeType[] = [
		// Allgemeine Hinweise
		...TreeStructureAllgemeinHinweisGlobal(application),
		// Projektdaten
		{
			label: 'Projektdaten',
			content: <ProjektDatenAntragEbusse hasComment={hasCommentProjektdaten} />,
			formStruc: getFormStrucProjektDatenAntragEbusse(application),
			hasComment: hasCommentProjektdaten,
		},
		// Antragsteller Global
		...TreeStructureAntragstellerGlobal(application, readOnly),
		// Selbsterlärung-KMU Global
		...TreeStructureSelbstErklaerungKMUGlobal(application, readOnly, allgemeineHinweiseKMU),
		// Beihilferelevanz-Erklärungen Global
		...TreeStructureSelbstErklaerungBeihilferelevanzGlobal(application, readOnly, allgemeineHinweiseBeihilferelevanz),
		// RUS-Erklärungen Global
		...TreeStructureSelbstErklaerungRUSGlobal(application, readOnly, allgemeineHinweiseRUS),
		// Deminismis-Selbsterklärung Global
		...TreeStructureDeMinimisGlobal(application, readOnly, allgemeineHinweiseDeminimis),
		// Fördervoraussetzung
		{
			label: 'Fördervoraussetzungen',
			content: <FoerdervoraussetzungAntragEbusse />,
			formStruc: getFormStrucFoerdervoraussetzungAntragEbusse(application),
		},
		// Projektbeschreibung Global
		...ProjektbeschreibungStructure(application, readOnly),
		// Kosten
		...AusgabenStructure(application, kostenKategoriesGroup, kostenKategories, readOnly, isKostenEditable),
		...EinahmeStructure(application, kostenKategoriesGroup, kostenKategories, readOnly, isKostenEditable),
		// Finanzierungplan Global
		...TreeStructureAntragFinanzierungsPlanGlobal(application),
		// Zeitplanung Global
		...TreeStructureZeitplanungGlobal(application, readOnly),
		// Anlagen und Erklärungen Global
		// Laut Formblatt, gibt es auch keine Anlagen
		...TreeStructureAnlagenGlobal(application, readOnly),
		...TreeStructureErklaerungGlobal(application, readOnly),
		// Vorzeitiger Massnahme Global
		...TreeStructureAntragVorzeitigerMassnahme(application, readOnly),
		// Abschluss Global
		...TreeStructureAntragAbschlussSeiteGlobal(application, readOnly),
		// Bescheid Global
		...TreeStructureAntragBescheidGlobal(application),
	];

	return treeNodes;
};

const ProjektbeschreibungStructure = (application: any, readOnly: boolean) => {
	// autofold/fold_next
	let nodes: TreeNodeType[] = [];
	const gegenStand = get(application, P.Projektbeschreibung_Elektrobusse.schema.attributes.Gegenstand_Der_Foerderung.path, '');

	switch (gegenStand) {
		case GEGENSTAND_DER_FOERDERUNG.Beschaffung:
			const hasCommentAusgangssituation = checkIfHasComment(
				readOnly,
				application,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausgangssituation_Pruefstatus.path,
			);
			const hasCommentBeschreibungDesVorhabens = checkIfHasComment(
				readOnly,
				application,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Beschreibung_Beschaffung_Pruefstatus.path,
			);
			const hasCommentAusschreibungVergabe = checkIfHasComment(
				readOnly,
				application,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausschreibung_Vergabe_Pruefstatus.path,
			);
			nodes = [
				{
					label: 'Projektbeschreibung',
					content: <ApplicationHeading title='Projektbeschreibung' description={PLATZHALTER_TEXT} />,
					hasComment: hasCommentAusgangssituation || hasCommentBeschreibungDesVorhabens || hasCommentAusschreibungVergabe,
					children: [
						{
							label: 'Ausgangssituation',
							content: <AusgangssituationAntragEbusseBeschaffung hasComment={hasCommentAusgangssituation} />,
							formStruc: getFormStrucAusgangssituationAntragEbusseBeschaffung(application),
							hasComment: hasCommentAusgangssituation,
						},
						{
							label: 'Beschreibung des Vorhabens',
							content: <BeschreibungDesVorhabensAntragEbusseBeschaffung hasComment={hasCommentBeschreibungDesVorhabens} />,
							formStruc: getFormStrucBeschreibungDesVorhabensAntragEbusseBeschaffung(application),
							hasComment: hasCommentBeschreibungDesVorhabens,
						},
						{
							label: 'Ausschreibung und Vergabe',
							content: <AusschreibungVergabeAntragEbusseBeschaffung />,
							formStruc: getFormStrucAusschreibungVergabeAntragEbusseBeschaffung(application),
							hasComment: hasCommentAusschreibungVergabe,
						},
					],
				},
			];
			break;
		case GEGENSTAND_DER_FOERDERUNG.Nachruestung:
			const hasCommentAusgangssituation_N = checkIfHasComment(
				readOnly,
				application,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausgangssituation_Pruefstatus.path,
			);
			const hasCommentBeschreibungDesVorhabens_N = checkIfHasComment(
				readOnly,
				application,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Beschreibung_Nachruestung_Pruefstatus.path,
			);
			const hasCommentBeschaffungLadeinfrastruktur_N = checkIfHasComment(
				readOnly,
				application,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ladeinfrastruktur_Nachruestung_Pruefstatus.path,
			);
			const hasCommentBeschaffungWasserstoff_N = checkIfHasComment(
				readOnly,
				application,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Wasserstoff_Nachruestung_Pruefstatus.path,
			);
			const hasCommentAusschreibungVergabe_N = checkIfHasComment(
				readOnly,
				application,
				P.Projektbeschreibung_Elektrobusse.schema.attributes.Pruefung_Ausschreibung_Vergabe_Pruefstatus.path,
			);

			nodes = [
				{
					label: 'Projektbeschreibung',
					content: <ApplicationHeading title='Projektbeschreibung' description={PLATZHALTER_TEXT} />,
					hasComment:
						hasCommentAusgangssituation_N ||
						hasCommentBeschreibungDesVorhabens_N ||
						hasCommentBeschaffungLadeinfrastruktur_N ||
						hasCommentBeschaffungWasserstoff_N ||
						hasCommentAusschreibungVergabe_N,
					children: [
						{
							label: 'Ausgangssituation',
							content: <AusgangssituationAntragEbusseNachruestung hasComment={hasCommentAusgangssituation_N} />,
							formStruc: getFormStrucAusgangssituationAntragEbusseBeschaffung(application),
							hasComment: hasCommentAusgangssituation_N,
						},
						{
							label: 'Beschreibung des Vorhabens',
							content: <BeschreibungDesVorhabensAntragEbusseNachruestung hasComment={hasCommentBeschreibungDesVorhabens_N} />,
							formStruc: getFormStrucBeschreibungDesVorhabensAntragEbusseNachruestung(application),
							hasComment: hasCommentBeschreibungDesVorhabens_N,
						},
						{
							label: 'Beschaffung von Ladeinfrastruktur',
							content: <BeschaffungVonLadeinfrastrukturAntragEbusseNachruestung hasComment={hasCommentBeschaffungLadeinfrastruktur_N} />,
							formStruc: getFormStrucBeschaffungVonLadeinfrastrukturAntragEbusseNachruestung(application),
							hasComment: hasCommentBeschaffungLadeinfrastruktur_N,
						},
						{
							label: 'Beschaffung einer Wasserstoff-Betankungsanlage',
							content: <BeschaffungEinerWasserstoffAntragEbusseNachruestung hasComment={hasCommentBeschaffungWasserstoff_N} />,
							formStruc: getFormStrucBeschaffungEinerWasserstoffAntragEbusseNachruestung(application),
							hasComment: hasCommentBeschaffungWasserstoff_N,
						},
						{
							label: 'Ausschreibung und Vergabe',
							content: <AusschreibungVergabeAntragEbusseNachruestung hasComment={hasCommentAusschreibungVergabe_N} />,
							formStruc: getFormStrucAusschreibungVergabeAntragEbusseNachruestung(application),
							hasComment: hasCommentAusschreibungVergabe_N,
						},
					],
				},
			];
			break;
	}

	return nodes;
};
const AusgabenStructure = (
	application: any,
	kostenKategoriesGroup: any,
	kostenKategories: any[],
	readOnly: boolean,
	hasCommentAusgabenUndFinanzierung: boolean,
) => {
	// autofold/fold_next
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Ausgabe, []).includes(KOSTEN_ARTEN.Investitionskosten)) {
		const unternehmenId = get(getLocalstorageToken(), 'organisationId');

		nodes = [
			{
				label: 'Investitionskosten',
				content: <InvestitionskostenAntragEbusse hasComment={hasCommentAusgabenUndFinanzierung} />,
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Investitionskosten),
				formStruc: getFormStrucInvestitionskostenAntragEbusse(application, unternehmenId, kostenKategories),
			},
			{
				label: 'Investitionskosten Übersicht',
				content: <InvestitionsUebersichtAntragEbusse />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
const EinahmeStructure = (
	application: any,
	kostenKategoriesGroup: any,
	_kostenKategories: any[],
	readOnly: boolean,
	hasCommentAusgabenUndFinanzierung: boolean,
) => {
	// autofold/fold_next
	let nodes: TreeNodeType[] = [];
	if (get(kostenKategoriesGroup, KOSTEN_POSITION.Einnahme, []).includes(KOSTEN_ARTEN.Eigenmittel)) {
		nodes = [
			{
				label: 'Eigenmittel',
				content: <EinnahmeAntragEbusse hasComment={hasCommentAusgabenUndFinanzierung} />,
				formStruc: getFormStrucEinnahmeAntragEbusse(application, get(getLocalstorageToken(), 'organisationId')),
				hasComment: checkIfAnyPositionNachKostenArtHasComment(readOnly, application, KOSTEN_ARTEN.Eigenmittel),
			},
			{
				label: 'Eigenmittel Übersicht',
				content: <EinnahmeUebersichtAntragEbusse />,
				isSummaryReport: true,
			},
		];
	}
	return nodes;
};
